export default __webpack_public_path__ + "static/media/Gilroy-Semibold.7726b19d.woff2";